export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/sesenta.jpg',
	   "funcion": 'Video Semanal.',
		"url" : 'https://www.facebook.com/reel/1722406465585398',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/rutast310326.jpg',
	   "funcion": 'Lunes Civico.',
		"url" : 'https://www.facebook.com/reel/909302048590271',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/CA310326.jpg',
	   "funcion": 'Contraloría en Acción.',
		"url" : 'https://www.facebook.com/reel/1271706321088771',
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]